import { Command } from '../interfaces';

export const sort = <T>(data: T[]) => data.sort();

export class SmokeSortCommand implements Command {
    isAndFilter() {
        return undefined;
    }

    execute<T>(data: T[]) {
        return sort(data);
    }
}
